import React from "react";

const LazyLoader = ({ text = "Loading..." }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(255, 255, 255, 0.6)",
        backdropFilter: "blur(4px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10
      }}
    >
      <i className="fa fa-spinner fa-spin fa-2x mb-2"></i>
      <div style={{ fontSize: "14px", color: "#333" }}>{text}</div>
    </div>
  );
};

export default LazyLoader;